// const baseurl = "https://payol.in/api/";
const baseurl = "https://payol.in/api/";
// const baseurl = "http://payol.in:3000/";

export { baseurl };
